import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Autocomplete,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormHelperText,
  Checkbox
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../components/button/PrimaryButton";
import SecondaryButton from "../../components/button/SecondaryButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import calendar from "../../assets/images/icon/calendar.svg";
import clock from "../../assets/images/icon/clock.svg";
import arrowDown from "../../assets/images/icon/arrow-down.svg";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomPopup from "../../components/popup/CustomPopup";
import { SearchId } from "../../services/SearchId";
import { postUpdatePet, SearchDdlPet } from "../../services/Dogbook";
// import { tempLineId1 } from "../../services/Api";
import { useLiff } from "react-liff";
import TopLogo from "../../components/layout/TopLogo";
import helper from "../../functions/helper";
import dayjs from "dayjs";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import globalStyle from "../../assets/styles/constants";
import { SearchDdlActivity } from "../../services/Dogbook";
import { postCreatePetNotification } from "../../services/Dogbook";
import CloseIcon from '@mui/icons-material/Close';
import SimpleTimePicker from "../../components/TimePicker/SimpleTimePicker";


import {
  SearchDdlFavShop,
} from "../../services/Dogbook";


const initialInputValues = {
  petId: "", // เพิ่ม field สำหรับ petId
  clinicId: "",
  activity1: "", // เพิ่ม field ใหม่
  note: "", // เพิ่ม field สำหรับรายละเอียดเพิ่มเติม
  notifyDate: null, // เพิ่ม field สำหรับเวลาที่นัดหมาย
  notifyTime: null, // เพิ่ม field สำหรับวันที่นัดหมาย
  reminder: null, // เพิ่ม field สำหรับความถี่การแจ้งเตือน
  otherClinic: false, // เพิ่ม field สำหรับ checkbox คลินิกอื่น
  otherClinicName: "", // เพิ่ม field สำหรับชื่อคลินิกอื่น
};

const initialErrorInput = {
  petId: false, // เพิ่ม field สำหรับ petId
  clinicId: false,
  activity1: false, // เพิ่ม field ใหม่
  note: false, // เพิ่ม field สำหรับรายละเอียดเพิ่มเติม
  notifyDate: false, // เพิ่ม field สำหรับเวลาที่นัดหมาย
  notifyTime: false, // เพิ่ม field สำหรับวันที่นัดหมาย
  reminder: false, // เพิ่ม field สำหรับความถี่การแจ้งเตือน
  otherClinicName: false, // เพิ่ม field สำหรับชื่อคลินิกอื่น
};




export default function AddNotification() {
  const navigate = useNavigate();

  const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
  const [saveNotiPopup, setSaveNotiPopup] = React.useState(false);
  const [userInput, setUserInput] = useState(initialInputValues);
  const [errorInput, setErrorInput] = useState(initialErrorInput);
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [tempTime, setTempTime] = useState(null);

  const [memberId, setMemberId] = useState(null);
  const [pet, setPet] = useState(null);
  const [petType, setPetType] = useState(null);
  const [favShop, setFavShop] = useState(null);
  const [defaultFavShop, setDefaultFavShop] = useState(null);
  const [appointmentOptions, setAppointmentOptions] = useState([]); // เพิ่ม state สำหรับเก็บ options จาก API

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  useEffect(() => {
    window.scrollTo(0, 0);
    getSearchId();
    getFavShop();
    getAppointmentOptions(); // เรียกฟังก์ชั่นใหม่
  }, []);

  async function getSearchId() {
    return await SearchId({
      params: { lineId: lineId || null },
    })
      .then(async (response) => {
        if (!response.data.body.memberId) {
          window.location.replace("/register");
        } else {
          setMemberId(response.data.body.memberId);
          getPet(response.data.body.memberId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getPet(member_id) {
    return await SearchDdlPet({
      params: { lineId: lineId || null },
      member_id: member_id,
    })
      .then(async (response) => {
        if (response.data.resultCode === 20000) {
          setPet(response.data.body);
          setUserInput(prev => ({
            ...prev,
            petId: response.data.body[0]?.id || ""
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function postUpdatePetLastDate() {
    let index = 0;
    if (Array.isArray(pet)) {
      index = pet.findIndex(
        (item) => item.id == userInput.petId
      );
    }
    setPetType(pet[index].species)
    const payload = {
      memberId: memberId,
      petId: userInput.petId,
      clinicId: userInput.otherClinic ? null : userInput.clinicId,
      otherClinic: userInput.otherClinic ? userInput.otherClinicName : null,
      activity1: userInput.activity1,
      note: userInput.note,
      notifyDate: userInput.notifyDate,
      notifyTime: userInput.notifyTime ? userInput.notifyTime.add(7, 'hour') : null,
      reminder: userInput.reminder,
    };
    try {
      const { data } = await postCreatePetNotification({ data: payload });
      console.log("resData.data >>", data);
      if (data.resultCode === 20000) {
        console.log(payload);
        setSaveNotiPopup(true);
      }
    } catch (error) {
      console.log("postUpdatePetLastDate error", error);
    }
  }

  async function getFavShop(keyword) {
    return await SearchDdlFavShop({
      params: { lineId: lineId || null },
      keyword: keyword,
    })
      .then(async (response) => {
        setFavShop(response.data.body);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAppointmentOptions() {
    return await SearchDdlActivity()
      .then(async (response) => {
        setAppointmentOptions(response.data.body);
      })
      .catch((error) => {
        console.log(error);
        // ในกรณีที่ API error ให้ใช้ default options
        const defaultOptions = [
          { id: "1_month", name: "แจ้งเตือนซ้ำ 1 เดือน" },
          { id: "3_months", name: "แจ้งเตือนซ้ำ 3 เดือน" },
          { id: "6_months", name: "แจ้งเตือนซ้ำ 6 เดือน" },
          { id: "1_year", name: "แจ้งเตือนซ้ำ 1 ปี" }
        ];
        setAppointmentOptions(defaultOptions);
      });
  }

  function validateRequiredFields() {
    const newErrors = { ...initialErrorInput };
    let hasError = false;

    // ตรวจสอบ field ที่จำเป็น
    if (!userInput.petId || userInput.petId === "") {
      newErrors.petId = true;
      hasError = true;
    }

    if (userInput.otherClinic) {
      // ถ้าเลือกคลินิกอื่น ให้ตรวจสอบชื่อคลินิก
      if (!userInput.otherClinicName || userInput.otherClinicName.trim() === "") {
        newErrors.otherClinicName = true;
        hasError = true;
      }
    } else {
      // ถ้าไม่เลือกคลินิกอื่น ให้ตรวจสอบ clinicId
      if (!userInput.clinicId || userInput.clinicId === null) {
        newErrors.clinicId = true;
        hasError = true;
      }
    }

    if (!userInput.activity1 || userInput.activity1 === "") {
      newErrors.activity1 = true;
      hasError = true;
    }

    if (!userInput.notifyDate || userInput.notifyDate === null) {
      newErrors.notifyDate = true;
      hasError = true;
    } else {
      // ตรวจสอบว่าวันที่เลือกต้องเป็นวันพรุ่งนี้เป็นต้นไป
      const selectedDate = dayjs(userInput.notifyDate);
      const tomorrow = dayjs().add(1, 'day').startOf('day');

      if (selectedDate.isBefore(tomorrow)) {
        newErrors.notifyDate = true;
        hasError = true;
      }
    }

    if (!userInput.notifyTime || userInput.notifyTime === "") {
      newErrors.notifyTime = true;
      hasError = true;
    }

    // อัปเดต error state
    setErrorInput(newErrors);

    return !hasError; // return true ถ้าไม่มี error
  }

  function fnRenderFavOption(props, option, { inputValue }) {
    const favHospital = `${option.name}`;

    const matches1 = match(favHospital, inputValue, { insideWords: true });
    const parts1 = parse(favHospital, matches1);

    return (
      <li {...props} className="text-left pl-1 border-address-list">
        <div>
          {parts1.map((part, index) => (
            <span
              key={index}
              style={{
                fontWeight: part.highlight ? 700 : 400,
                color: part.highlight ? "#0A4197" : "#8F8F8F",
              }}
            >
              {part.text}
            </span>
          ))}
        </div>
      </li>
    );
  }




  return (
    <div id="editnoti-page">
      <CustomPopup
        title={"บันทึกแจ้งเตือนพบคุณหมอ"}
        desc={
          petType === 1 ?
            "ระบบจะแจ้งเตือนคุณผ่าน Line @oneanddonefordogs​ เพื่อให้ได้รับการแจ้งเตือน กรุณาเปิดรับแจ้งเตือนไว้ตลอด" : "ระบบจะแจ้งเตือนคุณผ่าน Line @nextcombocat เพื่อให้ได้รับการแจ้งเตือน กรุณาเปิดรับแจ้งเตือนไว้ตลอด"
        }
        cancelText={"ปิด"}
        cancelFunction={() => {
          window.open("/dogbook", "_self");
          setSaveNotiPopup(false);
        }}
        open={saveNotiPopup}
        onClose={() => {
          window.open("/dogbook", "_self");
          setSaveNotiPopup(false);
        }}
      />
      <CustomPopup
        title={"ยกเลิกการตั้งแจ้งเตือน"}
        desc={
          "คุณกำลังยกเลิกตั้งแจ้งเตือนพบคุณหมอให้กับสัตว์เลี้ยง คุณสามารถกลับมาตั้งแจ้งเตือนใหม่ได้ในหน้า สมุดพกสัตว์เลี้ยงและข้อมูลผู้ใช้"
        }
        cancelFunction={() => {
          setOpenCancelPopup(false);
        }}
        actionFunction={() => {
          navigate(-1);
          setOpenCancelPopup(false);
        }}
        actionText="ยืนยัน"
        open={openCancelPopup}
        onClose={() => {
          setOpenCancelPopup(false);
        }}
      />
      <TopLogo />
      <div id="dogbook" className="relative gradientBg min-h-[calc(100vh-60px)] px-[13px] py-[27px]">
        <div className="flex flex-col justify-between bg-white py-[24px] px-[17px] rounded-[4px] min-h-[calc(100vh-123px)]">
          <div>
            <p className="text-lightBlue text-[28px] text-center">
              ตั้งเวลานัดหมาย
            </p>

            <p className="mt-[24px] text-left text-[24px] text-darkGray">
              เลือกสัตว์เลี้ยงที่ต้องการให้แจ้งเตือน
            </p>

            <div className="mt-[10px] relative">
              <FormControl fullWidth>
                <InputLabel style={{ marginLeft: "-14px" }} required>
                  ชื่อน้องหมา/น้องแมว
                </InputLabel>

                <Select
                  displayEmpty
                  IconComponent={() => null}
                  fullWidth
                  value={userInput.petId || ""}
                  variant="standard"
                  error={errorInput.petId}
                  onChange={(e) => {
                    setUserInput(prev => ({
                      ...prev,
                      petId: e.target.value
                    }));
                    setErrorInput(prev => ({
                      ...prev,
                      petId: false
                    }));
                  }}
                >
                  {pet &&
                    pet.map((item, i) => (
                      <MenuItem value={item.id} key={i}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <img
                className="absolute right-[10px] bottom-[8px] w-[15px] pointer-events-none"
                src={arrowDown}
                alt=""
              />
            </div>

            <div className="mt-[10px]">
              <Autocomplete
                disablePortal
                freeSolo
                disabled={userInput.otherClinic}
                value={defaultFavShop}
                onChange={(event, newValue) => {
                  if (newValue !== null) {
                    let updatedInput = {
                      ...userInput,
                      clinicId: newValue.id || 0,
                    };
                    setUserInput(updatedInput);
                    setErrorInput(prev => ({
                      ...prev,
                      clinicId: false
                    }));
                  } else {
                    let updatedInput = {
                      ...userInput,
                      clinicId: null,
                    };
                    setUserInput(updatedInput);
                  }
                }}
                options={favShop}
                getOptionLabel={(item) => item.name || ""}
                renderInput={(params) => (
                  <TextField
                    // disabled={hasClinic === "no" ? true : false}
                    {...params}
                    onChange={(e) => {
                      getFavShop(e.target.value);
                    }}
                    className="w-full text-[20px]"
                    label="คลินิก หรือ สถานที่"
                    error={errorInput.clinicId}
                    helperText="คลินิกไม่ถูกต้อง"
                    placeholder="ระบุชื่อคลิกนิก"
                    required
                    variant="standard"
                  />
                )}
                renderOption={fnRenderFavOption}
              />
            </div>
            
            <div className="mt-[10px] flex items-center gap-[4px] ml-[10px]">
              <Checkbox
                checked={userInput.otherClinic}
                onChange={(e) => {
                  setUserInput(prev => ({
                    ...prev,
                    otherClinic: e.target.checked,
                    clinicId: e.target.checked ? null : prev.clinicId,
                    otherClinicName: e.target.checked ? "" : prev.otherClinicName
                  }));
                  setDefaultFavShop(e.target.checked ? null : defaultFavShop);
                  setErrorInput(prev => ({
                    ...prev,
                    clinicId: false
                  }));
                }}
                sx={globalStyle.checkboxStyle}
              />
              <span className="text-[16px] text-gray">สถานที่อื่นๆ กรุณาระบุ</span>
              {userInput.otherClinic && (
                <TextField
                  className="flex-1 ml-[8px]"
                  value={userInput.otherClinicName}
                  onChange={(e) => {
                    setUserInput(prev => ({
                      ...prev,
                      otherClinicName: e.target.value
                    }));
                    setErrorInput(prev => ({
                      ...prev,
                      otherClinicName: false
                    }));
                  }}
                  placeholder=""
                  variant="standard"
                  error={errorInput.otherClinicName}
                  helperText="กรุณาระบุสถานที่"
                  required
                />
              )}
            </div>

            <div className="mt-[10px] relative">
              <FormControl fullWidth
                error={errorInput.activity1}
              >
                <InputLabel style={{ marginLeft: "-14px" }} required>
                  การนัดหมาย
                </InputLabel>
                <Select
                  displayEmpty
                  IconComponent={() => null}
                  fullWidth
                  value={userInput.activity1}
                  variant="standard"

                  onChange={(e) => {
                    const selectedActivity1 = e.target.value;
                    setUserInput(prev => ({
                      ...prev,
                      activity1: selectedActivity1
                    }));
                    setErrorInput(prev => ({
                      ...prev,
                      activity1: false
                    }));
                  }}
                >
                  {appointmentOptions &&
                    appointmentOptions.map((item, i) => (
                      <MenuItem value={item.id} key={i}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
                <FormHelperText>
                  กรุณาเลือกการนัดหมาย
                </FormHelperText>
              </FormControl>
              <img
                className="absolute right-[10px] bottom-[5px] w-[15px] pointer-events-none"
                src={arrowDown}
                alt=""
              />
            </div>



            <div className="flex flex-col gap-[0px] mt-[10px]">
              <p className="text-left text-gray">รายละเอียดการนัดหมายเพิ่มเติม (ถ้ามี)</p>
              <TextField
                style={{ height: "auto" }}
                name="note"
                className="w-full text-[20px] border border-indigo-600 text-area"
                multiline
                rows={3}
                // maxRows={3}
                label=""
                value={userInput.note}
                onChange={(e) => {
                  setUserInput(prev => ({
                    ...prev,
                    note: e.target.value
                  }));
                  setErrorInput(prev => ({
                    ...prev,
                    note: false
                  }));
                }}
                error={errorInput.note}
                variant="standard"
              />
            </div>

            <div className="mt-[10px] relative">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileDatePicker
                  className="w-full"
                  label="วันที่นัดหมาย"
                  variant="standard"
                  inputFormat="MM/DD/YYYY"
                  value={userInput.notifyDate}
                  minDate={dayjs().add(1, 'day')}
                  onChange={(value) => {
                    console.log(value);
                    setUserInput(prev => ({
                      ...prev,
                      notifyDate: value
                    }));
                    setErrorInput(prev => ({
                      ...prev,
                      notifyDate: false
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      required
                      {...params}
                      error={errorInput.notifyDate}
                      helperText="วันที่นัดหมายไม่ถูกต้อง"
                    />
                  )}
                />
                <img
                  className={
                    `absolute right-[10px] bottom-[8px] w-[15px] pointer-events-none ` +
                    (errorInput.notifyDate ? "!bottom-[35px]" : null)
                  }
                  src={calendar}
                  alt=""
                />
              </LocalizationProvider>
            </div>

            {/* <div className="mt-[10px] relative">
              <TextField
                className="w-full"
                variant="standard"
                required
                label="เวลาที่นัดหมาย"
                type="time"
                value={userInput.notifyTime ? dayjs(userInput.notifyTime).format('HH:mm') : ''}
                onChange={(e) => {
                  const timeValue = e.target.value;
                  if (timeValue && /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeValue)) {
                    const [hours, minutes] = timeValue.split(':');
                    const timeObj = dayjs().hour(parseInt(hours)).minute(parseInt(minutes));
                    setUserInput(prev => ({
                      ...prev,
                      notifyTime: timeObj
                    }));
                    setErrorInput(prev => ({
                      ...prev,
                      notifyTime: false
                    }));
                  } else {
                    setUserInput(prev => ({
                      ...prev,
                      notifyTime: null
                    }));
                  }
                }}
                error={errorInput.notifyTime}
                helperText="เวลาที่นัดพบคุณหมอไม่ถูกต้อง"
                sx={{
                  '& input[type="time"]::-webkit-calendar-picker-indicator': {
                    display: 'none !important'
                  },
                  '& input[type="time"]': {
                    textAlign: 'left !important',
                    paddingLeft: '0 !important'
                  },
                  '& .MuiInputBase-input': {
                    textAlign: 'left !important',
                    paddingLeft: '0 !important'
                  },
                  '& .MuiInput-input': {
                    textAlign: 'left !important',
                    paddingLeft: '0 !important'
                  }
                }}
              />
              <img
                className={
                  `absolute right-[10px] bottom-[8px] w-[15px] cursor-pointer z-10 ` +
                  (errorInput.notifyTime ? "!bottom-[35px]" : null)
                }
                src={clock}
                alt=""
                onClick={() => {
                  const timeInput = document.querySelector('input[type="time"]');
                  if (timeInput) {
                    timeInput.showPicker();
                  }
                }}
              />
            </div> */}

            <div className="mt-[10px] relative">
              <TextField
                className="w-full"
                variant="standard"
                required
                label="เวลาที่นัดหมาย"
                value={userInput.notifyTime ? dayjs(userInput.notifyTime).format('HH:mm') : ''}
                onChange={(e) => {
                  // อนุญาตให้พิมพ์ได้แต่จะไม่ update state จนกว่าจะกด OK จาก TimePicker
                }}
                onClick={() => {
                  setShowTimePicker(true);
                }}
                error={errorInput.notifyTime}
                helperText="เวลาที่นัดพบคุณหมอไม่ถูกต้อง"
                InputProps={{
                  readOnly: true,
                }}
              />
              <img
                className={
                  `absolute right-[10px] bottom-[8px] w-[15px] cursor-pointer z-10 ` +
                  (errorInput.notifyTime ? "!bottom-[35px]" : null)
                }
                src={clock}
                alt=""
                onClick={() => {
                  setShowTimePicker(true);
                }}
              />
            </div>

            {/* SimpleTimePicker Popup */}
            {showTimePicker && (
              <SimpleTimePicker
                onTimeChange={(time) => {
                  setTempTime(time);
                }}
                onConfirm={(time) => {
                  if (time) {
                    const timeObj = dayjs(time);
                    setUserInput(prev => ({
                      ...prev,
                      notifyTime: timeObj
                    }));
                    setErrorInput(prev => ({
                      ...prev,
                      notifyTime: false
                    }));
                  }
                  setShowTimePicker(false);
                }}
                onClose={() => {
                  setShowTimePicker(false);
                }}
              />
            )}


          </div>
          <div className="mt-[24px]">
            <p className="text-[24px] mb-[10px] text-darkGray">
              ต้องการให้แจ้งเตือนซ้ำ
            </p>

            <div className="flex gap-[36px] items-center text-gray">
              <div className="flex gap-[8px] items-center ">
                <Radio
                  checked={userInput.reminder === 1}
                  onClick={() => setUserInput(prev => ({
                    ...prev,
                    reminder: prev.reminder === 1 ? null : 1
                  }))}
                  value={1}
                  name="radio-buttons"
                  inputProps={{ "aria-label": 1 }}
                  sx={globalStyle.radioStyle}
                />
                <p className="text-[18px]">แจ้งเตือนซ้ำ 1 เดือน</p>
              </div>
              <div className="flex gap-[8px] items-center">
                <Radio
                  checked={userInput.reminder === 2}
                  onClick={() => setUserInput(prev => ({
                    ...prev,
                    reminder: prev.reminder === 2 ? null : 2
                  }))}
                  value={2}
                  name="radio-buttons"
                  inputProps={{ "aria-label": 2 }}
                  sx={globalStyle.radioStyle}
                />
                <p className="text-[18px]">แจ้งเตือนซ้ำ 3 เดือน</p>
              </div>
            </div>
            <div className="flex gap-[36px] items-center text-gray">
              <div className="flex gap-[8px] items-center">
                <Radio
                  checked={userInput.reminder === 3}
                  onClick={() => setUserInput(prev => ({
                    ...prev,
                    reminder: prev.reminder === 3 ? null : 3
                  }))}
                  value={3}
                  name="radio-buttons"
                  inputProps={{ "aria-label": 3 }}
                  sx={globalStyle.radioStyle}
                />
                <p className="text-[18px]">แจ้งเตือนซ้ำ 6 เดือน</p>
              </div>
              <div className="flex gap-[8px] items-center">
                <Radio
                  checked={userInput.reminder === 4}
                  onClick={() => setUserInput(prev => ({
                    ...prev,
                    reminder: prev.reminder === 4 ? null : 4
                  }))}
                  value={4}
                  name="radio-buttons"
                  inputProps={{ "aria-label": 4 }}
                  sx={globalStyle.radioStyle}
                />
                <p className="text-[18px]">แจ้งเตือนซ้ำ 1 ปี</p>
              </div>
            </div>



          </div>

          <div className="flex itesm-center gap-[13px] justify-center bg-white pt-[30px]">
            <SecondaryButton
              variant="outlined"
              className="w-full"
              onClick={() => setOpenCancelPopup(true)}
            >
              ยกเลิก
            </SecondaryButton>
            <PrimaryButton
              onClick={() => {
                if (validateRequiredFields()) {
                  postUpdatePetLastDate();
                }
              }}
              variant="outlined"
              className="w-full"
            >
              บันทึก
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}
